export const DASHBOARD_APPOINTMENT = 'dashboardAppointment';
export const APPOINTMENT_LIST = 'appointmentList';
export const APPOINTMENT_DETAILS = 'appointmentDetails';
